export function generateKey(bytes = 32) {
  const array = new Uint8Array(bytes);
  window.crypto.getRandomValues(array);

  return btoa(String.fromCharCode(...array));
}
